module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00039.4e79799.png";